import React, { useEffect, useMemo, useState } from "react";
import SellerTable from "./Components/SellerTable";
import { v4 as uuidv4 } from 'uuid'

import { addIDForTheList } from "../../../../generic/utils/addUIDForTheList";
import {
  ISellerDataHashItem,
  ISellerHashCustomerTopData,
  ISellerHeshCustomerItem,
  ISellerHeshGrowerItem,
} from "./types/hash";
import {
  Customer,
  ISellerTableProductItem,
  Product as ISellerProduct,
} from "../../../../modules/API/Seller/models/tableData";
import SellerToolbar from "./Components/SellerToolbar";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store/reducers/rootReducer";
import useDataFetcher from "../knisot/hooks/useFetchData";
import { Defaults } from "../../../../modules/API/Defaults/defaults";
import { IGrowerNodeGetResponse } from "../../../../modules/API/Defaults/models/growers";
import { SELLER } from "../../../../modules/API/Seller/seller";
import { format } from "date-fns";
import { LOAD, LOAD_END } from "../../../../../store/actions/actionsTypes";
import { ISellerChangeOrderProps } from "./types/handlerChangeOrder";
import useSellerController from "./Service/useSellerController";
import { ISellerForecastReqData, ISellerReqData } from "../../../../modules/API/Seller/models/reqests";
import useDebounce from "./Helpers/useDebounce";
 
import { IFreightCompanyItem } from "../../../../modules/API/Defaults/models/freightCompany";
import AppModal from "../../../../generic/ui/Modal/AppModal";
import ModalSelectFreightCompany from "./Components/ModalSelectFreightCompany";
import useFavoritCustomers from "../../../../generic/Favorites/Services/useFavoritCustomers";
import ModalCustomerFavorites from "../../../../generic/Favorites/Components/ModalCustomerFavorites";
import RemarkModal from "../arizot/View/RemarkModal";
 
import { TransportationIndex } from "./Components/Transportation";
import { handleNotifications } from "../../../../generic/utils/handleNotifications";
import SelectSizeModal from "./Components/SelectSizeModal";
import { Product } from "../../../../modules/API/Products/products";
import { ISizeItem } from "../../../../modules/API/Products/models/size";
import { IUpdateSizeInOrdersData } from "../../../../modules/API/Orders/models/reqestData";
import { Orders } from "../../../../modules/API/Orders/orders";
import useSellerSoketService from "./Service/useSellerSoketService";
import usePrint from "../../../../generic/hooks/usePrint";
import { PdfPreview } from "../../../../generic/ui/PdfPreview";
import { PDF_URLS } from "./Helpers/printConfig";

// const testList: ISellerTableProductItem[] = addIDForTheList(testData.Products)
const SellerMain = () => {
  const customerList = useSelector(
    (state: RootState) => state.defaults.clientList.list
  );
  const {
    postData,
    putData,
    createForecast,
    updateForecast
  } = useSellerController()
  const isCustomer = useSelector((state: RootState) => state.mainReducer.user?.rights.includes('CUSTOMER'))
  const [date, setDate] = useState<Date>(new Date());
  const [input, setInput] = useState<string>("");
  const [selectedGrower, setSelectedGrower] = useState<number>(0);
  const [selectedCustomer, setSelectedCustomer] = useState<number>(0);
  const [listWithID, setListWithID] = useState<ISellerTableProductItem[]>([]);
  const [tableMeta, setTableMeta] = useState<Customer[]>([]);
  const [changeData, setChangeData] = useState<ISellerChangeOrderProps | null>(null)
  const [selectedProductItem, setSelectedProductItem] = useState<ISellerTableProductItem | null>(null)
  const [isOpenFreightCompanyModal, setIsOpenFreightCompanyModal] = useState<boolean>(false)
  const [isOpenFavoritesModal, setIsOpenFavoritesModal] = useState(false)
  const [isOpenRemarkModal, setIsOpenRemarkModal] = useState(false)
  const [isOpenTransportationModal, setIsOpenTransportationModal] = useState(false)
  const [isOpenTahazitRemarkModal, setIsOpenTahazitRemarkModal] = useState(false)
  const [isOpenSelectSizeModal, setIsOpenSelectSizeModal] = useState(false)
  const [selectedFreightCompany, setSelectedFreightCompany] = useState<number>(0)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const debouncedChangeData  = useDebounce(changeData, 400)
  const [selectedItemDestination, setSelectedItemDestination] = useState<{
    id: string,
    growerID?: number,
    qty: number,
    customerID: number,
    freightCompanyID?: number,
    remark?: string,
    tahazitRemark?: string
  } | null>(null)
  const dispatch = useDispatch();

  const {
    handleGetPdf,
    handleSharePdf,
    file,
    handleDownloadPdf,
    handleClearFile,
    handleOpenPdf
  } = usePrint()
  const handlePrintCustomerReport = async () => {
    const dataUrl = PDF_URLS.printCustomerReport
    await handleGetPdf(`${dataUrl}?Date=${format(date, "yyyyMMdd")}`)
  }
  const { data: growerData } = useDataFetcher<IGrowerNodeGetResponse>(
    Defaults.getGrowerList,
    "data"
  );
  const {
    data: dataSize
  } = useDataFetcher<ISizeItem[]>(
    Product.getSizesByProduct,
    selectedProductItem?.Product.ProductID.toString() || ""
  )
  const {
    data: dataFreightCompany
  } = useDataFetcher<IFreightCompanyItem[]>(
    Defaults.getTblFreightCompany,
    "data"
  )
  const {
    list: favoritesList,
    isLoading: isLoadingFavorites,
    createFavorite,
    deleteFavorite,
    changeOrder
  } = useFavoritCustomers()
  
  useSellerSoketService({
    state: listWithID,
    setState: setListWithID,
    setTableMeta: setTableMeta,
    date: date
  })
  // const listWithID: ISellerTableProductItem[] = useMemo(() => {
  //   if(!tableData) return []
  //   return addIDForTheList(tableData.Products)
  // }, [tableData])
  const handleSelectProduct = (item: ISellerTableProductItem, isEdit?: boolean) => {
    setSelectedProductItem(item)
    if(isEdit) {
      setIsEdit(true)
    } else {
      setIsEdit(false)
    }
    handleModalSelectSize()
  }

  const handleChangeSize = async (sizeID: string) => {
    if(!selectedProductItem) return

    const formedData: IUpdateSizeInOrdersData = {
      Date: format(date, "yyyyMMdd"),
      NewSize: sizeID,
      ProductID: selectedProductItem.Product.ProductID,
      Size: selectedProductItem.Product.SizeID,
      VarietyID: selectedProductItem.Product.VarietyID
    }
    try {
      dispatch({type: LOAD})
      const newListWithID = [...listWithID]
      const res = await Orders.updateSizeInOrders(formedData)

      setListWithID(newListWithID.map((item,) => item.id === selectedProductItem.id ? res : item))
      handleModalSelectSize()
    } catch (error) {
      handleNotifications("שגיאה בעדכון גודל", {type: "error"})
      console.log(error)
    } finally {
      dispatch({type: LOAD_END})
    }
  }

  const handleAddProduct = (sizeID: string) => {
    if(!selectedProductItem) return
    
    const findMatchProduct = listWithID.find(item => item.Product.SizeID.trim() === sizeID.trim() && item.Product.ProductID === selectedProductItem.Product.ProductID && item.Product.VarietyID === selectedProductItem.Product.VarietyID)
    
    if(findMatchProduct) {
      handleNotifications("פריט זה כבר קיים", {type: "warning"})
      return
    }
    const newProduct: ISellerProduct = {
      ...selectedProductItem.Product,
      SizeID: sizeID
    }

    const newProductItem: ISellerTableProductItem = {
      ...selectedProductItem,
      id: uuidv4(),
      Product: newProduct,
      Customers: selectedProductItem.Customers.map(customer => {
        return {
          ...customer,
          OrderDetail: {
            ...customer.OrderDetail,
            Order_Pallets: 0,
            OrderPacks: 0,
            OrderWeight: 0,
            SupplyQty: 0,
            SupplyWeight: 0,
            Supply_Pallets: 0,
            RecID: 0
          }
        }
      }),
      Growers: selectedProductItem.Growers.map(grower => {
        return {
          ...grower,
          Order_Pallets: 0,
          OrderPacks: 0,
          OrderWeight: 0,
          Forecast: {
            ...grower.Forecast,
            RecID: 0,
            ActualAmnt: 0,
            ActualPallets: 0,
            ActualWeight: 0,
            ForecastAmnt: 0,
            ForecastPallets: 0,
            ForecastWieght: 0
          },
          Customers: grower.Customers.map(customer => {
            return {
              ...customer,
              
              OrderDetail: {
                ...customer.OrderDetail,
                Order_Pallets: 0,
                RecID: 0,
                OrderWeight: 0,
                OrderPacks: 0,
                SupplyQty: 0,
                SupplyWeight: 0,
                Supply_Pallets: 0
              }
            }
          })
        }
      }),
      OrderPacks: 0,
      OrderWeight: 0,
      Order_Pallets: 0,
      SupplyQty: 0,
      SupplyWeight: 0,
      Supply_Pallets: 0,
      ForecastAmnt: 0,
      ForecastPallets: 0,
      ForecastWieght: 0,
    
    }
    // add product to listWithID near the product with the same productID and varietyID
    const newListWithID = [...listWithID];
    const productIndex = newListWithID.findIndex(item => item.Product.ProductID === selectedProductItem.Product.ProductID && item.Product.VarietyID === selectedProductItem.Product.VarietyID)
    newListWithID.splice(productIndex + 1, 0, newProductItem)
    setListWithID(newListWithID)
    handleModalSelectSize()
    
  }
  const hashData = useMemo(() => {
    if (!listWithID) return {};
    const hash = listWithID.reduce((acc: ISellerDataHashItem, cur, index) => {
      if (!cur.id) return acc;

      const growers = cur.Growers.reduce(
        (accGrower: ISellerHeshGrowerItem, curGrower, indexGrower) => {
          const customers = curGrower.Customers.reduce(
            (
              accCustomer: ISellerHeshCustomerItem,
              curCustomer,
              indexCustomer
            ) => {
              accCustomer[curCustomer.Customer.CustomerID] = {
                index: indexCustomer,
              };
              return accCustomer;
            },
            {}
          );

          accGrower[curGrower.Grower.GrowerID] = {
            index: indexGrower,
            customers: customers,
          };

          return accGrower;
        },
        {}
      );

      const customersTop = cur.Customers.reduce(
        (
          accCustomer: ISellerHashCustomerTopData,
          curCustomer,
          indexCustomer
        ) => {
          accCustomer[curCustomer.Customer.CustomerID] = {
            index: indexCustomer,
          };
          return accCustomer;
        },
        {}
      );

      acc[cur.id] = {
        index: index,
        customers: customersTop,
        growers: growers,
      };
      return acc;
    }, {});
    return hash;
  }, [listWithID]);

  const handleChangeOrder = async ({
    id,
    customerTopID,
    growerID,
    customerInnerID,
    isForecast,
    qty,
    FreightCompanyID,
    isFreightCompany,
    isRemark,
    remark,
    isPermanent,
    isTahazitRemark,
    tahazitRemark,
  }: ISellerChangeOrderProps) => {
    const newArr = [...listWithID];
    const productIndex = hashData[id].index;
    
    if(isTahazitRemark && tahazitRemark && growerID) {
      // find forecast and update comments filed
      const growerIndex = hashData[id].growers[growerID].index;
      const updatedGrowers = [...newArr[productIndex].Growers];
      updatedGrowers[growerIndex].Forecast.Comments = tahazitRemark;
      newArr[productIndex] = {
        ...newArr[productIndex],
        Growers: updatedGrowers
      }
      setListWithID(newArr);
      const formedData: ISellerForecastReqData = {
        RecID: updatedGrowers[growerIndex].Forecast.RecID,
        ProductID: newArr[productIndex].Product.ProductID,
        GrowerID: growerID,
        ForecastPallets: updatedGrowers[growerIndex].Forecast.ForecastPallets,
        VarietyID: newArr[productIndex].Product.VarietyID,
        SizeID: newArr[productIndex].Product.SizeID,
        Collection_Date: format(date, "yyyyMMdd"),
        Comments: tahazitRemark
      };
      updateForecast(formedData) // Убираем await
      setListWithID(newArr);
      handleModalTahazitRemark()
    }
    // Обрабатываем только завершенные операции (remark и freightCompany) с сервером
    else if (isRemark && remark && customerInnerID ) {
      if(growerID) {
        const updatedCustomers = [...newArr[productIndex].Growers];
        const growerIndex = hashData[id].growers[growerID].index;
        const customerIndex = hashData[id].growers[growerID].customers[customerInnerID].index;
        updatedCustomers[growerIndex].Customers[customerIndex].OrderDetail.Remarks = remark;
        newArr[productIndex] = {
          ...newArr[productIndex],
          Growers: updatedCustomers
        }
        const formedData: ISellerReqData = {
          RecID: newArr[productIndex].Growers[growerIndex].Customers[customerIndex].OrderDetail.RecID,
          Remarks: remark,
          LineType: 2,
          CustomerID: customerInnerID,
          GrowerID: growerID,
          Order_Pallets: newArr[productIndex].Growers[growerIndex].Customers[customerIndex].OrderDetail.Order_Pallets,
          ProductID: newArr[productIndex].Product.ProductID,
          VarietyID: newArr[productIndex].Product.VarietyID,
          SizeID: newArr[productIndex].Product.SizeID,
          Delivery_Date: format(date, "yyyyMMdd"),
          FreightCompanyID: FreightCompanyID || 0
        }
        putData(formedData) // Убираем await для избежания блокировки UI
        setListWithID(newArr);
      }
      else {
        const updatedCustomers = [...newArr[productIndex].Customers];
        const customerIndex = hashData[id].customers[customerInnerID].index;
        updatedCustomers[customerIndex].OrderDetail.Remarks = remark;
        newArr[productIndex] = {
          ...newArr[productIndex],
          Customers: updatedCustomers
        }
        const formedData: ISellerReqData = {
          RecID: newArr[productIndex].Customers[customerIndex].OrderDetail.RecID,
          Remarks: remark,
          LineType: 1,
          CustomerID: customerInnerID,
          ProductID: newArr[productIndex].Product.ProductID,
          VarietyID: newArr[productIndex].Product.VarietyID,
          SizeID: newArr[productIndex].Product.SizeID,
          Delivery_Date: format(date, "yyyyMMdd"),
          FreightCompanyID: FreightCompanyID || 0,
          Order_Pallets: newArr[productIndex].Customers[customerIndex].OrderDetail.Order_Pallets,
          GrowerID: 0
        }
        putData(formedData) // Убираем await
        setSelectedFreightCompany(0)
        setListWithID(newArr);
      }
      handleModalRemark()

    }
    else if(FreightCompanyID && growerID && customerInnerID && isFreightCompany) {
      const updatedCustomers = [...newArr[productIndex].Growers];
      const growerIndex = hashData[id].growers[growerID].index;
      const customerIndex = hashData[id].growers[growerID].customers[customerInnerID].index;
      updatedCustomers[growerIndex].Customers[customerIndex].OrderDetail.FreightCompanyID = FreightCompanyID;
      newArr[productIndex] = {
        ...newArr[productIndex],
        Growers: updatedCustomers
      }
      console.log(newArr[productIndex].Growers[growerIndex].Customers[customerIndex].OrderDetail.Order_Pallets)
      console.log(qty)
      const formedData: ISellerReqData = {
        RecID: newArr[productIndex].Growers[growerIndex].Customers[customerIndex].OrderDetail.RecID,
        FreightCompanyID: FreightCompanyID,
        LineType: 2,
        CustomerID: customerInnerID,
        GrowerID: growerID,
        Order_Pallets: newArr[productIndex].Growers[growerIndex].Customers[customerIndex].OrderDetail.Order_Pallets,
        ProductID: newArr[productIndex].Product.ProductID,
        VarietyID: newArr[productIndex].Product.VarietyID,
        SizeID: newArr[productIndex].Product.SizeID,
        Delivery_Date: format(date, "yyyyMMdd"),
        LinkGrowerWithFreightCompany: !!isPermanent
      }
      putData(formedData) // Убираем await
      setSelectedFreightCompany(0)
      setListWithID(newArr);
    }
    // Для остальных случаев - только UI обновления (оптимистичные)
    else if(isForecast && growerID) {
      const growerIndex = hashData[id].growers[growerID].index;
      const updatedGrowers = [...newArr[productIndex].Growers];
      updatedGrowers[growerIndex].Forecast = {
        ...updatedGrowers[growerIndex].Forecast,
        ForecastPallets: qty
      }
      newArr[productIndex] = {
        ...newArr[productIndex],
        Growers: updatedGrowers
      }
      setListWithID(newArr);
    }
    else if (growerID && customerInnerID) {
      const growerIndex = hashData[id].growers[growerID].index;
      const customerInnerIndex = hashData[id].growers[growerID].customers[customerInnerID].index;
      const updatedGrowers = [...newArr[productIndex].Growers];
      const updatedCustomers = [...updatedGrowers[growerIndex].Customers];
      const updatedOrderDetail = {
        ...updatedCustomers[customerInnerIndex].OrderDetail,
        Order_Pallets: qty,
        // RecID: qty === 0 ? 0 : updatedCustomers[customerInnerIndex].OrderDetail.RecID
      };
      
      updatedCustomers[customerInnerIndex] = {
        ...updatedCustomers[customerInnerIndex],
        OrderDetail: updatedOrderDetail
      }
      updatedGrowers[growerIndex] = {
        ...updatedGrowers[growerIndex],
        Customers: updatedCustomers
      }
      newArr[productIndex] = {
        ...newArr[productIndex],
        Growers: updatedGrowers
      }
      setListWithID(newArr);
    }
    else if (customerTopID) {
      const customerTopIndex = hashData[id].customers[customerTopID].index;
      const updatedCustomers = [...newArr[productIndex].Customers];
      const updatedOrderDetail = {
        ...updatedCustomers[customerTopIndex].OrderDetail,
        Order_Pallets: qty
      }
      updatedCustomers[customerTopIndex] = {
        ...updatedCustomers[customerTopIndex],
        OrderDetail: updatedOrderDetail
      }
      newArr[productIndex] = {
        ...newArr[productIndex],
        Customers: updatedCustomers
      }
      setListWithID(newArr);
    }
    
    return { 
      id: id, 
      growerID: growerID, 
      customerTopID: customerTopID, 
      customerInnerID: customerInnerID, 
      isForecast: isForecast,
      qty: qty,
      isFreightCompany: isFreightCompany,
      FreightCompanyID: FreightCompanyID,
      isRemark: isRemark,
      remark: remark,
      isPermanent: isPermanent
    }
  };

  const onInputChange = async (data: ISellerChangeOrderProps) => {
    const result = await handleChangeOrder(data);
    setChangeData(result);
  };

  useEffect(() => {
    if (!debouncedChangeData) return;

    const { 
      id, 
      customerTopID, 
      growerID, 
      customerInnerID, 
      qty, 
      isForecast, 
      FreightCompanyID,
    } = debouncedChangeData;
    
    // Пропускаем операции, которые уже завершены в handleChangeOrder
    if (debouncedChangeData.isRemark || debouncedChangeData.isFreightCompany) return;
    
    const productIndex = hashData[id]?.index;
    if (productIndex === undefined) return;
    
    const currentProductData = listWithID[productIndex];
    if (!currentProductData) return;

    if(isForecast && growerID) {
      const growerIndex = hashData[id].growers[growerID]?.index;
      if (growerIndex === undefined) return;
      
      const order = currentProductData.Growers[growerIndex];
      if (!order) return;

      const formedData: ISellerForecastReqData = {
        RecID: order.Forecast.RecID,
        ProductID: currentProductData.Product.ProductID,
        GrowerID: growerID,
        ForecastPallets: qty,
        VarietyID: currentProductData.Product.VarietyID,
        SizeID: currentProductData.Product.SizeID,
        Collection_Date: format(date, "yyyyMMdd"),
      };

      const isNewOrder = order.Forecast.RecID === 0;
      
      (async () => {
        try {
          let res: any;
          if (isNewOrder) {
            res = await createForecast(formedData);
            // Только для новых записей обновляем RecID после успешного создания
            if(res && res[0]) {
              setListWithID(prev => {
                const newArr = [...prev];
                const newProductIndex = hashData[id]?.index;
                const newGrowerIndex = hashData[id]?.growers[growerID]?.index;
                
                if (newProductIndex !== undefined && newGrowerIndex !== undefined) {
                  newArr[newProductIndex].Growers[newGrowerIndex].Forecast = {
                    ...newArr[newProductIndex].Growers[newGrowerIndex].Forecast,
                    RecID: res[0].RecID
                  };
                }
                return newArr;
              });
            }
          } else {
            await updateForecast(formedData);
          }
        } catch (error) {
          console.error('Forecast update failed:', error);
        }
      })();
    }
    
    if (growerID && customerInnerID) {
      const growerIndex = hashData[id].growers[growerID]?.index;
      const customerInnerIndex = hashData[id].growers[growerID]?.customers[customerInnerID]?.index;
      
      if (growerIndex === undefined || customerInnerIndex === undefined) return;
      
      const order = currentProductData.Growers[growerIndex]?.Customers[customerInnerIndex];
      if (!order) return;

      const formedData: ISellerReqData = {
        RecID: order.OrderDetail.RecID,
        ProductID: currentProductData.Product.ProductID,
        CustomerID: order.Customer.CustomerID,
        GrowerID: growerID,
        Order_Pallets: qty,
        VarietyID: currentProductData.Product.VarietyID,
        SizeID: currentProductData.Product.SizeID,
        Delivery_Date: format(date, "yyyyMMdd"),
        LineType: 2,
        FreightCompanyID: FreightCompanyID || 0
      };
      const isNewOrder = order.OrderDetail.RecID === 0;
      
      (async () => {
        try {
          let res: any;
          if (isNewOrder) {
            res = await postData(formedData);
          } else {
            res = await putData(formedData);
          }
          
          // Обновляем только RecID для новых записей
          if (res) {
            setListWithID(prev => {
              const newArr = [...prev];
              const newProductIndex = hashData[id]?.index;
              const newGrowerIndex = hashData[id]?.growers[growerID]?.index;
              const newCustomerInnerIndex = hashData[id]?.growers[growerID]?.customers[customerInnerID]?.index;
              
              if (newProductIndex !== undefined && newGrowerIndex !== undefined && newCustomerInnerIndex !== undefined) {
                newArr[newProductIndex].Growers[newGrowerIndex].Customers[newCustomerInnerIndex].OrderDetail = {
                  ...newArr[newProductIndex].Growers[newGrowerIndex].Customers[newCustomerInnerIndex].OrderDetail,
                  RecID: res.RecID,
                  FreightCompanyID: res.FreightCompanyID || 0
                };
              }
              return newArr;
            });
          }
        } catch (error) {
          console.error('Order update failed:', error);
        }
      })();

      // Расчет общего количества по производителю и обновление верхнего уровня
      const totalByGrower = currentProductData.Growers.reduce((acc, cur) => {
        const customerInOrder = cur.Customers.find(c => c.Customer.CustomerID === order.Customer.CustomerID);
        return acc + (customerInOrder?.OrderDetail.Order_Pallets || 0);
      }, 0);
      
      const customerOrder = currentProductData.Customers.find(customer => customer.Customer.CustomerID === order.Customer.CustomerID);
     
      if(customerOrder && totalByGrower > customerOrder.OrderDetail.Order_Pallets) {
        const topLevelFormedData: ISellerReqData = {
          RecID: customerOrder.OrderDetail.RecID,
          ProductID: currentProductData.Product.ProductID,
          CustomerID: order.Customer.CustomerID,
          GrowerID: growerID,
          Order_Pallets: totalByGrower,
          VarietyID: currentProductData.Product.VarietyID,
          SizeID: currentProductData.Product.SizeID,
          Delivery_Date: format(date, "yyyyMMdd"),
          LineType: 1,
          FreightCompanyID: FreightCompanyID || 0,
        };
        
        (async () => {
          try {
            let res: any;
            const isNewTopOrder = customerOrder.OrderDetail.RecID === 0;
            if (isNewTopOrder) {
              res = await postData(topLevelFormedData);
            } else {
              res = await putData(topLevelFormedData);
            }
            console.log(res)
            if (res) {
              setListWithID(prev => {
                const newArr = [...prev];
                const newProductIndex = hashData[id]?.index;
                const customerTopIndex = hashData[id]?.customers[order.Customer.CustomerID]?.index;
                
                if (newProductIndex !== undefined && customerTopIndex !== undefined) {
                  newArr[newProductIndex].Customers[customerTopIndex].OrderDetail = {
                    ...newArr[newProductIndex].Customers[customerTopIndex].OrderDetail,
                    RecID: res.RecID,
                    Order_Pallets: totalByGrower
                  };
                 // add order_pallet qty to top level customer
                }
                return newArr;
              });
            }
          } catch (error) {
            console.error('Top level order update failed:', error);
          }
        })();
      }
    }

    if (customerTopID) {
      const customerTopIndex = hashData[id].customers[customerTopID]?.index;
      if (customerTopIndex === undefined) return;
      
      const order = currentProductData.Customers[customerTopIndex];
      if (!order) return;

      const formedData: ISellerReqData = {
        RecID: order.OrderDetail.RecID,
        ProductID: currentProductData.Product.ProductID,
        CustomerID: order.Customer.CustomerID,
        GrowerID: 0,
        Order_Pallets: qty,
        VarietyID: currentProductData.Product.VarietyID,
        SizeID: currentProductData.Product.SizeID,
        Delivery_Date: format(date, "yyyyMMdd"),
        LineType: 1,
        FreightCompanyID: FreightCompanyID || 0,
      };
  
      const isNewOrder = order.OrderDetail.RecID === 0;
  
      (async () => {
        try {
          let res: any;
          if (isNewOrder) {
            res = await postData(formedData);
          } else {
            res = await putData(formedData);
          }
          console.log(res)
          // Обновляем только RecID для новых записей
          setListWithID(prev => {
            const newArr = [...prev];
            const newProductIndex = hashData[id]?.index;
            const newCustomerTopIndex = hashData[id]?.customers[customerTopID]?.index;
            
            if (newProductIndex !== undefined && newCustomerTopIndex !== undefined) {
              newArr[newProductIndex].Customers[newCustomerTopIndex].OrderDetail = {
                ...newArr[newProductIndex].Customers[newCustomerTopIndex].OrderDetail,
                RecID: res.RecID
              };
            }
            return newArr;
          });
          if (res && isNewOrder) {
          }
        } catch (error) {
          console.error('Customer top order update failed:', error);
        }
      })();
    } 
  }, [debouncedChangeData, ]);

  // useEffect(() => {
  //   (async () => {
  //     dispatch({ type: LOAD });
  //     try {
  //       const res = await SELLER.getSellerPGC(format(date, "yyyyMMdd"));
  //       setTableMeta(res.Metadata);
  //       setListWithID(addIDForTheList(res.Products));
  //     } catch {
  //     } finally {
  //       dispatch({ type: LOAD_END })
  //     }
  //   })();
  // }, [date, dispatch])

  const render = useMemo(() => {
    let data = [...listWithID];
     data = listWithID.map((item) => {
        let newItem = { ...item };
        if(selectedGrower !== 0) {
          newItem.Growers = item.Growers.filter(grower => grower.Grower.GrowerID === selectedGrower)
        }
        if(selectedCustomer !== 0) {
          newItem.Customers = newItem.Customers.filter(customer => customer.Customer.CustomerID === selectedCustomer)
          newItem.Growers = newItem.Growers.map(grower => {
            let newGrower = { ...grower }
            newGrower.Customers = newGrower.Customers.filter(customer => customer.Customer.CustomerID === selectedCustomer)
            return newGrower
          })
        }
        
        
        return newItem
    }).filter((item) =>  (
        `${item.Product.ProductDesc.trim()} ${item.Product.VarietyDesc.trim()} ${item.Product.SizeID}`
          .toLowerCase()
            .includes(input.toLowerCase() 
            ) 
      )
    )
    return data;
  }, [listWithID, input, selectedGrower, selectedCustomer])

  const renderTitle = useMemo(() => {
    if (selectedCustomer === 0) return tableMeta;
      return tableMeta.filter((item) => item.CustomerID === selectedCustomer || item.CustomerID === 0)
  }, [selectedCustomer, tableMeta])

  const handleModalFreightCompany = () => {
    setIsOpenFreightCompanyModal(!isOpenFreightCompanyModal)
  }
  const handleModalFavorites = () => {
    setIsOpenFavoritesModal(!isOpenFavoritesModal)
    if(isOpenFavoritesModal) {
      // reload page
      window.location.reload()
    }
  }
  const handleModalRemark = () => {
    setIsOpenRemarkModal(!isOpenRemarkModal)
  }
  const handleModalTahazitRemark = () => {
    setIsOpenTahazitRemarkModal(!isOpenTahazitRemarkModal)
  } 
  const openFreightCompanyModal = (id: string, growerID: number, customerID: number, freightCompanyID: number, qty: number, remark: string) => {
    handleModalFreightCompany()
    setSelectedItemDestination({
      id: id,
      growerID: growerID,
      customerID: customerID, 
      freightCompanyID: freightCompanyID,
      qty: qty,
      remark: remark
    })
  }
  const handleChangeFreightCompany = (id: number, isPermanent: boolean) => {
    if(!selectedItemDestination) return
    handleModalFreightCompany()
    handleChangeOrder({
      id: selectedItemDestination.id,
      growerID: selectedItemDestination.growerID,
      customerInnerID: selectedItemDestination.customerID,
      FreightCompanyID: id,
      qty: selectedItemDestination.qty,
      isFreightCompany: true,
      isPermanent: isPermanent
    })
  }
  const handleOpenRemarkModal = (
    id: string, 
    growerID: number, 
    customerID: number, 
    freightCompanyID: number, 
    qty: number, 
    remark: string,
    lineType?: number) => {
    handleModalRemark()
    if(lineType) {
      setSelectedItemDestination({
        id: id,
        customerID: customerID,
        qty: qty,
        freightCompanyID: freightCompanyID,
        remark: remark
      })
      return
    }
    setSelectedItemDestination({
      id: id,
      growerID: growerID,
      customerID: customerID,
      qty: qty,
      freightCompanyID: freightCompanyID,
      remark: remark
    })
  }
  const handleOpenTahazitRemarkModal = (
    id: string, 
    growerID: number, 
    customerID: number, 
    qty: number, 
    tahazitRemark: string
  ) => {
    handleModalTahazitRemark()
    setSelectedItemDestination({
      id: id,
      growerID: growerID,
      customerID: customerID,
      qty: qty,
      tahazitRemark: tahazitRemark
    })
  }
  const handleChangeRemark = (remark: string) => {
    if(!selectedItemDestination) return
    handleChangeOrder({
      id: selectedItemDestination.id,
      growerID: selectedItemDestination.growerID,
      customerInnerID: selectedItemDestination.customerID,
      remark: remark,
      qty: selectedItemDestination.qty,
      isRemark: true,
      FreightCompanyID: selectedItemDestination.freightCompanyID || 0
    })

  }
  const handleChangeTahazitRemark = (tahazitRemark: string) => {
    if(!selectedItemDestination) return
    handleChangeOrder({
      id: selectedItemDestination.id,
      growerID: selectedItemDestination.growerID,
      tahazitRemark: tahazitRemark,
      qty: selectedItemDestination.qty,
      isTahazitRemark: true,
    })
  }
  const handleModalTransportation = () => {
    setIsOpenTransportationModal(!isOpenTransportationModal)
  }
  const handleModalSelectSize = () => {
    setIsOpenSelectSizeModal(!isOpenSelectSizeModal)
  }
  const freightCompanyProps = {
    list: dataFreightCompany || [],
    defaultID: selectedFreightCompany,
    setFreightCompanyID: setSelectedFreightCompany,
    selectedItemDestination: selectedItemDestination,
    handleChangeFreightCompany: handleChangeFreightCompany
  }
  const favoritesProps = {
    list: favoritesList,
    isLoading: isLoadingFavorites,
    createFavorite: createFavorite,
    deleteFavorite: deleteFavorite,
    changeOrder: changeOrder
  }


  const remarkProps = {
    isActive: true,
    handleSave: handleChangeRemark,
    data: {
      title: selectedItemDestination?.remark || '',
      body: selectedItemDestination?.remark || '',
      id: selectedItemDestination?.id || ''
    }
  }
  const tahazitRemarkProps = {
    isActive: true,
    handleSave: handleChangeTahazitRemark,
    data: {
      title: selectedItemDestination?.tahazitRemark || '',
      body: selectedItemDestination?.tahazitRemark || '',
      id: selectedItemDestination?.id || ''
    }
  }
  const selectSizeProps = {
    item: selectedProductItem,
    handleSave: isEdit ? handleChangeSize : handleAddProduct,
    sizeList: dataSize || [],
    isEdit: isEdit
  }
 
  const toolbar = (
    <SellerToolbar
      input={input}
      setInput={setInput}
      date={date}
      setDate={setDate}
      isCustomer={isCustomer}
      onPrint={handlePrintCustomerReport}
      onOpenFavorites={handleModalFavorites}
      onOpenTransportation={handleModalTransportation}
      customerList={customerList || []}
      growerList={growerData?.growers || []}
      selectedCustomer={selectedCustomer}
      setSelectedCustomer={setSelectedCustomer}
      selectedGrower={selectedGrower}
      setSelectedGrower={setSelectedGrower}
    />
  )

  return (
    <TableSection>
      {file && (
        <AppModal
          size="lg"
          title="תצוגה מקדימה"
          controlFunc={handleClearFile}
          Children={PdfPreview}
          childrenProps={{
            file,
            handleSharePdf,
            handleDownloadPdf,
            handleClearFile,
            handleOpenPdf,
          }}
        />
      )}
      {isOpenSelectSizeModal && (
        <AppModal
          title="בחר גודל"
          Children={SelectSizeModal}
          childrenProps={selectSizeProps}
          controlFunc={handleModalSelectSize}
          // size="md"
        />
      )}
      {isOpenTransportationModal && (
        <AppModal
          title="משלוחים"
          Children={TransportationIndex}
          childrenProps={{
            date: format(date, "yyyyMMdd")
          }}
          controlFunc={handleModalTransportation}
          size="lg"
        />
      )}
      {isOpenRemarkModal && (
        <AppModal
          title="הערה"
          Children={RemarkModal}
          childrenProps={remarkProps}
          controlFunc={handleModalRemark}
          // size="md"
        />
      )}
      {isOpenTahazitRemarkModal && (
        <AppModal
          title="הערת תחזית"
          Children={RemarkModal}
          childrenProps={tahazitRemarkProps}
          controlFunc={handleModalTahazitRemark}
          // size="md"
        />
      )}
      {isOpenFreightCompanyModal && (
        <AppModal
          title="בחר חברת הובלה"
          Children={ModalSelectFreightCompany}
          childrenProps={freightCompanyProps}
          controlFunc={handleModalFreightCompany}
          // size="md"
        />
      )}
      {isOpenFavoritesModal && (
        <AppModal
          title="מועדפים"
          Children={ModalCustomerFavorites}
          childrenProps={favoritesProps}
          controlFunc={handleModalFavorites}
          size="md"
        />
      )}
      <SellerTable
        meta={renderTitle}
        list={render}
        count={render.length}
        toolbar={toolbar}
        handleChangeOrder={onInputChange}
        openFreightCompanyModal={openFreightCompanyModal}
        openRemarkModal={handleOpenRemarkModal}
        handleSelectProduct={handleSelectProduct}
        openTahazitRemarkModal={handleOpenTahazitRemarkModal}
      />
    </TableSection>
  );
};

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  padding: 0.5em;
  overflow: hidden;
`;

export default SellerMain;
